



import AuctionListComponent from "@/components/admin/auction/auctionListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AuctionListPage",
  components: {
    AuctionListComponent,
  },
})
export default class AuctionListPage extends Vue {}
